/**
 * @author shaojingchao
 * @date 2019/06/19
 * @project zhinengzujuan
 * @description 组卷api
 */

import { API_URL } from '../config'
import request from '../utils/request'

// 智能组卷
const paperviewUrl = {
  cfg: API_URL + 'v1/paper/config', // 配置数据
  downAnswerSheet: API_URL + 'v1/paper/answer-card',
  savePaper: API_URL + 'v1/paper/save-paper',
  replacePaper: API_URL + 'v1/paper/replace-all',
  replaceOne: API_URL + 'v1/paper/replace-one',
  testList: API_URL + 'v1/paper/test-list',
  saveTmpPaper: API_URL + 'v1/paper/save-tmp',
  getTmpPaper: API_URL + 'v1/paper/get-tmp',
  docDown: API_URL + 'v1/paper/down'
}

// 智能组卷
const ZNZJUrl = {
  cfg: API_URL + 'v1/intelligent/config', // 配置数据
  createPaper: API_URL + 'v1/intelligent/create-paper',
  finePaper: API_URL + 'v1/home/fine-paper',
  subject: API_URL + 'v1/home/subject',
  links: API_URL + 'v1/home/friend-links'
}

// 组卷共用
const zjCommon = {
  collect: API_URL + 'v1/test/collect',
  collectCancel: API_URL + 'v1/collect/cancel',
  comment: API_URL + 'v1/test/comment',
  correct: API_URL + 'v1/test/correct',
  singleDown: API_URL + 'v1/test/single-down',
  canPower: API_URL + 'v1/user/can-power'
}

// 模版组卷
const tplZJUrl = {
  config: API_URL + 'v1/template/config',
  tplList: API_URL + 'v1/template/list',
  delTpl: API_URL + 'v1/template/del-template',
  tplDetail: API_URL + 'v1/template/detail',
  tplCustom: API_URL + 'v1/template/custom',
  saveTpl: API_URL + 'v1/template/save-template',
  createPaper: API_URL + 'v1/template/create-paper'
}
// 考点组卷
const KDZJUrl = {
  config: API_URL + 'v1/kl/config',
  testList: API_URL + 'v1/kl/test-list'
}

// 章节组卷
const ZJZJUrl = {
  config: API_URL + 'v1/chapter/config',
  testList: API_URL + 'v1/chapter/test-list'
}

// 名校名卷
const MXMJUrl = {
  config: API_URL + 'v1/doc/config',
  docList: API_URL + 'v1/doc/doc-list',
  testList: API_URL + 'v1/doc/test-list',
  docDown: API_URL + 'v1/doc/down'
}

// 搜索
const search = {
  config: API_URL + 'v1/search/config',
  testList: API_URL + 'v1/search/test-list'
}

// 配置信息
export const getZnzjCfgApi = (params, config) => request.get(ZNZJUrl.cfg, { params, ...config })

// 配置信息
export const znzjCreatePaperApi = (data, config) => request.post(ZNZJUrl.createPaper, data, config)

/* 试卷预览 */
// 试卷配置
export const paperviewCfgApi = (params, config) => request.get(paperviewUrl.cfg, { params, ...config }) // subjectID

// 试卷配置
export const paperDownloadAnswerSheetApi = (data, config) => request.post(paperviewUrl.downAnswerSheet, data, config)

// 试卷存档
export const savePaperApi = (data, config) => request.post(paperviewUrl.savePaper, data, config)

// 替换试卷
export const replacePaperApi = (data, config) => request.post(paperviewUrl.replacePaper, data, config)

// 单题替换
export const replaceOneApi = (data, config) => request.post(paperviewUrl.replaceOne, data, config)

// 试题列表
export const testListApi = (params, config) => request.get(paperviewUrl.testList, {params, ...config})

// 临时保存试卷
export const saveTmpPaperApi = (data, config) => request.post(paperviewUrl.saveTmpPaper, data, config) // subjectID, paper

// 获取试卷最后一次保存状态
export const getTmpPaperApi = (params, config) => request.get(paperviewUrl.getTmpPaper, {params, ...config}) // subjectID

// 下载试卷
export const paperViewDocDownApi = (data, config) => request.post(paperviewUrl.docDown, data, config)

/* 组卷共用操作 */
// 取消收藏试题
export const collectCancelApi = (params, config) => request.get(zjCommon.collectCancel, {params, ...config})

// 收藏试题
export const collectQuesApi = (data, config) => request.post(zjCommon.collect, data, config)

// 试题评价
export const commentApi = (data, config) => request.post(zjCommon.comment, data, config)

// 试题纠错
export const correctApi = (data, config) => request.post(zjCommon.correct, data, config)

// 单题下载
export const singleDownApi = (data, config) => request.post(zjCommon.singleDown, data, config)

// 单题下载
export const canPowerApi = (params, config) => request.get(zjCommon.canPower, {params, ...config})

// 模板组卷配置
export const tplConfigApi = (params, config) => request.get(tplZJUrl.config, {params, ...config})

// 模板列表
export const tplListApi = (params, config) => request.get(tplZJUrl.tplList, {params, ...config})

// 删除模板
export const delTplApi = (params, config) => request.get(tplZJUrl.delTpl, {params, ...config})

// 模板详情
export const tplDetailApi = (params, config) => request.get(tplZJUrl.tplDetail, {params, ...config})

// 自定义模板
export const tplCustomApi = (params, config) => request.get(tplZJUrl.tplCustom, {params, ...config})

// 保存模板
export const saveTplApi = (data, config) => request.post(tplZJUrl.saveTpl, data, config)

// 生成试卷
export const createPaperApi = (data, config) => request.post(tplZJUrl.createPaper, data, config)

// 考点组卷配置数据
export const kdzjConfigApi = (params, config) => request.get(KDZJUrl.config, {params, ...config})

// 考点组卷试卷列表
export const kdzjTestListApi = (params, config) => request.get(KDZJUrl.testList, {params, ...config})

// 章节组卷配置数据
export const zjzjConfigApi = (params, config) => request.get(ZJZJUrl.config, {params, ...config})

// 章节组卷试卷列表
export const zjzjTestListApi = (params, config) => request.get(ZJZJUrl.testList, {params, ...config})

// 名校名卷配置数据
export const mxmjConfigApi = (params, config) => request.get(MXMJUrl.config, {params, ...config})

// 名校名卷试卷列表
export const mxmjDocListApi = (params, config) => request.get(MXMJUrl.docList, {params, ...config})

// 名校名卷试题列表
export const mxmjTestListApi = (params, config) => request.get(MXMJUrl.testList, {params, ...config})

// 下载试卷
export const mxmjDocDownApi = (data, config) => request.post(MXMJUrl.docDown, data, config)

// 搜索配置数据
export const searchConfigApi = (params, config) => request.get(search.config, {params, ...config})

// 搜索试题列表
export const searchTestListApi = (params, config) => request.get(search.testList, {params, ...config})
